module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro1.409ea2a4.mp3";